import img from '../img/404.png';

/*

 */
export default function NotFound() {
	return (
		<div style={{width:'100%', overflowY:'hidden'}}>
			{/*<h1 style={{width:'100vw', padding:60}}>Snap, something went wrong! </h1>*/}
			<a href={"/"}><img alt={"404"} src={img}  style={{width:'100%'}} /></a>
		</div>
	)
}
